import React, { useRef, useEffect, useState } from 'react'
import { Box, Skeleton } from '@mui/material'

interface Props {
    height: number,
    gap: number
}

const SkeletonList = ({ height, gap }: Props) => {
    const containerRef = useRef<HTMLElement>(null)
    const [count, setCount] = useState<number[]>([])

    useEffect(() => {
        if (containerRef.current) {
            const n = Math.floor(containerRef.current.clientHeight / (height + gap))
            setCount(Array.from({ length: n }, (_, i) => i + 1))
        }
    }, [])  // eslint-disable-line

    return (
        <Box ref={containerRef} className='w-100 h-100 d-flex flex-column' sx={{gap: `${gap}px`}}>
            {count.map(i => (<Skeleton key={i} variant="rounded" height={height} />))}
        </Box>
    )   
}

export default SkeletonList